<template>
    <div class="note-item v3">
        <div class="note-msg">
            <div class="note-time">
                <div class="time-wrapper text-overflow">
                    <!--                    时间: -->
                    {{ note.time }}
                </div>
            </div>
            <div class="note-address">
                <div class="address-wrapper text-overflow">
                    <!--                    地点: -->
                    {{ note.address }}
                </div>
            </div>
        </div>
        <div class="note-btn" @click="jumpPanoPage"></div>
    </div>
</template>

<script>
import {jumpPano, jumpFinePano} from '../../../constant/JumpFunc';
import StatisticConst from '../../../constant/StatisticConst';
export default {
    props: {
        note: {
            type: Object,
            default: null
        }
    },
    methods: {
        jumpPanoPage() {
            StatisticConst.goPano();
            if (this.note.isInter) {
                this.note.uid & jumpFinePano(this.note.uid);
            }
            else {
                this.note.pid & jumpPano(this.note.pid);
            }
        }
    }

};
</script>
<style lang='scss'>
.note-item {
    width: 349px;
    height: 95px;
    margin-bottom: 15px;
    position: relative;
    background-size: 101%;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('../../../assets/v2/note/item.png');
    .note-msg {
        position: absolute;
        top: 33px;
        left: 12px;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #fff;
        text-shadow: 0 0 5px #62fbff;
        width: calc(100% - 140px);
        white-space: nowrap;

        .note-time,
        .note-address {
            height: 12px;
            display: flex;
            align-items: center;
        }

        .note-address {
            margin-top: 7px;
        }
    }
    .note-btn {
        position: absolute;
        width: 123px;
        height: 60px;
        top: 18px;
        right: 4px;
        background-position: center;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url('../../../assets/v2/note/view-btn.png');
    }
    &.v3 {
        width: 357px;
        height: 103px;
        background-size: cover;
        background-image: url('../../../assets/v3/note/itemFrame.png');
        display: flex;
        justify-content: space-between;
        align-items: center;

        .note-msg {
            position: static;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            margin-left: 20px;
            width: 150px;
            font-size: 14px;
            font-family: PingFang-SC-Regular;
            font-weight: 400;
            color: #FFFFFF;
            .note-time{
                width: 100%;
                padding-left: 50px;
                background-size: 40px 21px;
                background-position: left center;
                background-repeat: no-repeat;
                background-image: url(../../../assets/v3/note/time.png);
            }
            .note-address {
                width: 100%;
                margin-top: 16px;
                margin-bottom: 3px;
                padding-left: 50px;
                background-size: 39px 21px;
                background-position: left center;
                background-repeat: no-repeat;
                background-image: url(../../../assets/v3/note/place.png);
            }
        }
        .note-btn {
            width: 147px;
            height: 69px;
            background-image: url(../../../assets/v3/note/panoBtn.png);
        }
    }
}
</style>